import React from 'react';
import Form from 'components/form';
import { H2 } from 'components/typography';
import { Row } from 'components/layout';
import { CopyIcon } from 'routes/admin/style';
import LogoutMenu from 'routes/admin/components/logout-menu';
import { useTranslation } from 'i18n';
import { useHistory } from 'react-router';
import { WithMargin } from 'components/layout';
import createSignInCode from 'graphql/admin/create-sign-in-code-mutation';
import { asyncAction, copyToClipboard } from 'utils/js';
import toast from 'services/toast';
import { createBackgroundTemplateMutation } from 'graphql/admin/backgrounds';
import Axios from 'axios';

function AdminSignInCodeForm() {
  const { t } = useTranslation();
  const history = useHistory();
  const [code, setCode] = React.useState('');

  async function onSubmit(data) {
    console.log('SUBIT ', data);
    try {
      const result = await createBackgroundTemplateMutation({
        input: { title: data.title, description: data.description },
      });
      if (result.error) {
        toast.error('Fehler ');
      } else {
        console.log('AAA ');
        const url = result.data.data.url;
        const file = data.file;
        const config = {
          /*params: {
              Key: values.name,
              ContentType
            },*/
          headers: {
            Accept: '*/*',
            'Content-Type': 'image/png',
          },
        };

        const [error] = await asyncAction(Axios.put(url, file, config));
        if (error) {
          toast.error('Fehler Upload ');
          return;
        }
        toast.success('Erfolgreich erstellt');
        history.push('/admin/background/list');
      }
      console.log('SSS', result);
    } catch (error) {
      console.log('ERROR ', error);
    }

    // createSignInCode({}).then((response) => {
    //   if (response.isSuccess) {
    //     setCode(response.getField('data.code'));
    //   }
    // });
  }

  // function copyLoginUrl(value) {
  //   return function () {
  //     try {
  //       copyToClipboard(window.location.origin + '/register?code=' + value);
  //       toast.success(t('Successfully copied to clipboard'));
  //     } catch (error) {
  //       toast.success(t('Something went wrong'));
  //     }
  //   };
  // }

  return (
    <>
      <LogoutMenu />
      <H2>{t('Background')}</H2>
      <Form initialValues={{ code }} onSubmit={onSubmit}>
        {(form) => (
          <>
            <br />
            <br />
            Title
            <Form.TextInput
              name="title"
              style={{ width: '40%' }}
              label={t('Title')}
            />
            Description
            <Form.TextInput
              name="description"
              style={{ width: '40%' }}
              label={'Description'}
            />
            <Form.FileInput
              name="file"
              style={{ width: '40%' }}
              label={t('File')}
              accepts={['image/jpeg', 'image/png']}
            />
            <WithMargin top="30px">
              <Row>
                <Form.SubmitButton
                  label={t('Create')}
                  onClick={form.handleSubmit}
                />
                <WithMargin left="30px">
                  <Form.Button
                    secondary
                    label={t('Back to list')}
                    onClick={() => history.push('/admin/background/list')}
                  />
                </WithMargin>
              </Row>
            </WithMargin>
          </>
        )}
      </Form>
    </>
  );
}

export default AdminSignInCodeForm;
